<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3NGSWA/tc-custom/1.png?1685327829176?1705540719301" alt="This image is the cover for the book The Pink Peacock"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Pink Peacock
      </h1>
      <p class="bookDescription body article font2">
        <p>Princess Rose demands a pink peacock, no other colour will do.<br/>Her peacock escapes and leads her on a colourful adventure. <br/>Rose discovers new places and makes a new friend, but will she ever find her pet?<br/>Beautifully detailed illustrations explore and celebrate an array of colours, reminding us of the importance of rainbows in our lives.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicolette Carter
      </h2>
      
      <p class="authorDescription body article">Nicolette Carter is a winning artist from BBC One, Series 2 of Home Is Where the Art Is. She has been a professional artist for many years and has always dreamed of illustrating her own stories. You can find out more on her website, www.nicolettecarter.com [//www.nicolettecarter.com]. In the nineties and noughties, she wrote and performed poetry for Brixton Poets and South Poetry Magazine. She also works as a primary school teacher and is the subject leader for literacy. She loves to share, inspire and create stories with her pupils. Nicolette’s ten-year-old daughter, Fran, also loves to write and draw. When she discovered her mum’s stories tucked away in an old file, she suggested that Nicolette submit them to Austin Macauley, and that is how this story began.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cf734d72